<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm1"></a></p>
<div class="fmhT"><b>Jossey-Bass Teacher</b></div>
<div class="fmtx1"><i>Jossey-Bass Teacher</i> provides K-12 teachers with essential knowledge and tools to create a positive and lifelong impact on student learning. Trusted and experienced educational mentors offer practical classroom-tested and theory-based teaching resources for improving teaching practice in a broad range of grade levels and subject areas. From one educator to another, we want to be your first source to make every day your best day in teaching. <i>Jossey-Bass Teacher</i> resources serve two types of informational needs—essential knowledge and essential tools.</div>
<div class="fmtx">Essential knowledge resources provide the foundation, strategies, and methods from which teachers may design curriculum and instruction to challenge and excite their students. Connecting theory to practice, essential knowledge books rely on a solid research base and time-tested methods, offering the best ideas and guidance from many of the most experienced and well-respected experts in the field.</div>
<div class="fmtx">Essential tools save teachers time and effort by offering proven, ready-to-use materials for in-class use. Our publications include activities, assessments, exercises, instruments, games, ready reference, and more. They enhance an entire course of study, a weekly lesson, or a daily plan. These essential tools provide insightful, practical, and comprehensive materials on topics that matter most to K-12 teachers.</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// musc_9781118040942_oeb_fm1_r1.vue?dcb59546